import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { Contrato } from '../base/vo/contrato';
import { Field } from '../base/vo/formulario';
import { ModalSucessoComponent } from '../modal/modal-sucesso/modal-sucesso.component';
import { ModalDocumentoService } from './modal-documentos.service';


@Component({
  selector: 'app-modal-documentos',
  templateUrl: './modal-documentos.component.html',
  styleUrls: ['./modal-documentos.component.scss'],
})
export class ModalDocumentosComponent implements OnInit {
  @ViewChild('modalSucesso')
  public modalSucesso: ModalSucessoComponent;

  @Input() confirmFunc: Function;
  @Input() successMessage: string;

  private stepCurrentPage: number;
  private stepPages: number;
  private fromLater = false;
  private savedDocumentsCounter = 0;

  private userIP: string;
  private userGeocode: string;

  public active: number;
  public displayModal = false;
  public documentsStep: string[];
  public enableStep = true;
  public geocodeError = false;
  public isSigning = false;
  public urlMaterialApoio = environment.urlMaterialApoio;

  public documents: Contrato[];
  public documentsModal: Contrato[];

  public formGroup: FormGroup;
  public fields: Field[] = [
    {
      controlName: 'liAceito',
      label: 'Declaro que li e aceito.',
    },
  ];

  constructor(
    private readonly autenticacaoService: AutenticacaoService,
    private readonly formBuilder: FormBuilder,
    private readonly modalDocumentoService: ModalDocumentoService
  ) { }

  ngOnInit() {
    if (this.modalDocumentoService.control) {
      return;
    }

    this.modalDocumentoService
      .getDocuments(+this.autenticacaoService.usuarioLogado.username)
      .pipe(
        tap((response) => {
          if (response) {
            this.documents = response;
            this.modalDocumentoService.control = true;
            this.getUserIp();
            this.setDocuments();
          }
        })
      )
      .subscribe();

    this.setFormGroup();
  }

  private setDocuments() {
    if (this.documents.length === 1) {
      this.enableStep = false;
    }

    this.stepCurrentPage = 0;
    this.stepPages = Math.trunc(this.documents.length / 3) + 1;

    this.setDocumentsStep();
    this.openDialog();
  }

  private setFormGroup() {
    this.formGroup = this.formBuilder.group({
      liAceito: ['', [Validators.requiredTrue]],
    });
  }

  private setDocumentsStep() {
    this.active = 0;

    if (this.documents.length >= 3) {
      const initialIndex = this.stepCurrentPage * 3;
      const finalIndex = initialIndex + 3;

      this.documentsStep = this.documents
        .slice(initialIndex, finalIndex)
        .map((document) => document.tipoDocumento);

      this.documentsModal = this.documents.slice(initialIndex, finalIndex);
    } else {
      this.documentsStep = this.documents.map(
        (document) => document.tipoDocumento
      );

      this.documentsModal = this.documents;
    }

    this.stepCurrentPage = this.stepCurrentPage + 1;
  }

  private prepareToSign() {
    this.isSigning = true;

    this.modalDocumentoService
      .getPosition()
      .pipe(
        tap(
          (pos) => {
            if (pos.message === 'User denied Geolocation') {
              this.geocodeError = true;
              this.isSigning = false;
            } else {
              this.geocodeError = false;
              this.userGeocode = `${pos.coords.latitude} ${pos.coords.longitude}`;
              this.sign();
            }
          }
        ),
      )
      .subscribe();
  }

  private sign() {
    if (this.geocodeError) {
      return;
    }

    this.modalDocumentoService
      .documentAssignment(
        this.documentsModal[this.active].id,
        +this.autenticacaoService.usuarioLogado.username,
        {
          nomePrestador: this.autenticacaoService.usuarioLogado.nome,
          idPrestador: +this.autenticacaoService.usuarioLogado.username,
          ip: this.userIP,
          geocode: this.userGeocode,
        }
      )
      .pipe(
        tap(_ => {
          this.isSigning = false;
          this.fromLater = false;
          this.savedDocumentsCounter++;
          this.next();
        }),
        catchError(error => {
          this.isSigning = false;
          this.modalDocumentoService.displayErrorOdontoBackendApiError(error.error);

          return of(error);
        }),
      )
      .subscribe();
  }

  private next() {
    this.active = this.active + 1;
    this.formGroup.reset();
    this.formGroup.controls['liAceito'].enable();

    if (this.active > this.documentsStep.length - 1) {
      if (this.stepCurrentPage >= this.stepPages) {
        this.closeDialog();
        if (this.savedDocumentsCounter > 0) {
          this.modalSucesso.openDialog();
        }
        if (this.fromLater) {
          this.savedDocumentsCounter = 0;
        }
      } else {
        this.setDocumentsStep();
      }
    }
  }

  public save() {
    if (this.isSigning) {
      return;
    }

    const control = this.formGroup.controls['liAceito'];

    control.enable();

    if (this.formGroup.valid) {
      control.disable();
      this.prepareToSign();
    } else {
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty();
    }
  }

  public later() {
    if (!this.isSigning) {
      this.fromLater = true;
      this.next();
    }
  }

  public openDialog() {
    this.displayModal = true;
  }

  public closeDialog() {
    this.displayModal = false;
  }

  getUserIp() {
    this.modalDocumentoService
      .getIP()
      .pipe(
        tap((response) => {
          this.userIP = response;
        })
      )
      .subscribe();
  }

  getUserPosition() {
    return this.modalDocumentoService
      .getPosition()
      .pipe(
        tap(
          (pos) => {
            if (pos.message === 'User denied Geolocation') {
              this.geocodeError = true;
            } else {
              this.userGeocode = `${pos.coords.latitude} ${pos.coords.longitude}`;
            }
          }
        ),
      )
      .subscribe();
  }

  public confirmSuccessModal() {
    this.modalSucesso.closeDialog();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-documentos/modal-documentos.component.ts